// Talks to the Applypa Chrome extension through window.postMessage. The
// extension's content script on this site (content_applypa.js) relays these to
// its background worker, so this works without knowing the extension's ID.

const STORE_EXTENSION_ID = 'pdiakkjcojbfjlignljognenofmadfmd';
export const EXTENSION_STORE_URL = `https://chromewebstore.google.com/detail/applypa/${STORE_EXTENSION_ID}`;

let nextRequestId = 0;

// Resolves with the extension's reply, or null if nothing answers in time
// (extension missing, disabled, or too old to know this request).
export function askExtension(type, timeoutMs = 1500) {
  return new Promise((resolve) => {
    nextRequestId += 1;
    const requestId = `applypa-${Date.now()}-${nextRequestId}`;

    const onMessage = (event) => {
      if (event.source !== window || event.origin !== window.location.origin) return;
      const data = event.data;
      if (!data || data.source !== 'applypa-extension' || data.requestId !== requestId) return;
      cleanup();
      resolve(data.response || null);
    };
    const timer = setTimeout(() => {
      cleanup();
      resolve(null);
    }, timeoutMs);
    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener('message', onMessage);
    }

    window.addEventListener('message', onMessage);
    window.postMessage({ source: 'applypa-web', type, requestId }, window.location.origin);
  });
}

export async function isExtensionInstalled() {
  const reply = await askExtension('PING', 800);
  return !!reply?.ok;
}

// Versions before 1.2.0 don't answer PING, but they do answer APPLYPA_STATUS
// over externally_connectable — so a silent PING plus a STATUS reply means
// installed but too old, not missing.
function hasOlderExtension() {
  const runtime = window.chrome?.runtime;
  if (!runtime?.sendMessage) return Promise.resolve(false);
  const ids = [...new Set([process.env.VUE_APP_EXTENSION_ID, STORE_EXTENSION_ID].filter(Boolean))];
  const askOne = (id) => new Promise((resolve) => {
    try {
      runtime.sendMessage(id, { type: 'APPLYPA_STATUS' }, (reply) => {
        void runtime.lastError;
        resolve(!!reply?.ok);
      });
    } catch (err) {
      resolve(false);
    }
  });
  return Promise.all(ids.map(askOne)).then((found) => found.some(Boolean));
}

// 'ready' | 'outdated' | 'missing'
export async function detectExtension() {
  if (await isExtensionInstalled()) return 'ready';
  return (await hasOlderExtension()) ? 'outdated' : 'missing';
}
